<div class="wccard p-3">
  <p class="f-16 font-weight-600 mb-4">
    Similar companies like {{companyData?.name}}
  </p>
  <div class="similar-company-container" *ngIf="!showSimilarCompaniesLoader && similarCompanies?.length > 0">
    <div class="similar-companies" *ngFor="let company of similarCompanies">
      <div class="comp-info">
        <div class="company-logo">
          <span *ngIf="company.companylogo"><img src="{{company.companylogo}}" alt=""> </span>
          <span *ngIf="!company.companylogo"
            class="
              company-img
              d-flex
              align-items-center
              justify-content-center
            "
            [ngClass]="{
              'red-circle': i % 4 == 0,
              'yellow-circle': i % 4 == 1,
              'green-circle': i % 4 == 2,
              'blue-circle': i % 4 == 3
            }"
            style="border: none !important"
          >
            {{ company.name.trim()[0] }}
          </span>
        </div>
        <p class="f-14 font-weight-600 mb-2 text-capitalize">
          {{company.name}}
        </p>
        <p class="f-14 font-weight-400 mb-2 text-capitalize">
          {{company.industry}}
        </p>
        <div class="d-flex text-9696">
          <span><i class="fa-regular fa-buildings mr-2"></i></span>
          <span class="text-truncate text-capitalize" style="width: 155px;"> {{company?.location?.name}} &nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span><i class="fa-regular fa-users mr-2"></i>  {{company.size}}</span>
        </div>
      </div>
      <div class="button-section">
        <button data-testid="auto-app-similar-companies-button-1" class="btn-trms-regular mr-2" (click)="openCompanyCompare(company)">Compare</button>
        <button data-testid="auto-app-similar-companies-button-2" class="btn-trms-small" (click)="openViewInsights(company)">View Insights</button>
      </div>
    </div>
  </div>

  <div *ngIf="showSimilarCompaniesLoader" class="skeleton-loader">
      <div class="row" >
  <div class="col-md-4" *ngFor="let i of [1,2,3]">
    <div class="shimmer-card">
      <div class="shimmer shimmer-circle-similar mb-3"></div>
      <div class="shimmer shimmer-line-similar w-75 mb-2"></div>
      <div class="shimmer shimmer-line-similar w-50 mb-3"></div>
      <div class="shimmer shimmer-line-similar w-50 mb-2"></div>
      <div class="shimmer shimmer-line-similar w-25 mb-4"></div>
      <div class="d-flex justify-content-between">
        <div class="shimmer shimmer-button-similar"></div>
        <div class="shimmer shimmer-button-similar"></div>
      </div>
    </div>
  </div>
</div>
  <div class="row">
  <div class="col-md-4" *ngFor="let i of [1,2,3]">
    <div class="shimmer-card">
      <div class="shimmer shimmer-circle-similar mb-3"></div>
      <div class="shimmer shimmer-line-similar w-75 mb-2"></div>
      <div class="shimmer shimmer-line-similar w-50 mb-3"></div>
      <div class="shimmer shimmer-line-similar w-50 mb-2"></div>
      <div class="shimmer shimmer-line-similar w-25 mb-4"></div>
      <div class="d-flex justify-content-between">
        <div class="shimmer shimmer-button-similar"></div>
        <div class="shimmer shimmer-button-similar"></div>
      </div>
    </div>
  </div>
</div>
  </div>



  <div *ngIf="similarCompanies?.length > 9" class="text-center" (click)="openViewMoreSimilarCompanies()">
    <p class="f-16 font-weight-600 text-webbtree-green pointer">View More</p>
  </div>
</div>
